import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative bg-[#1C2541] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-25">
        <img
          src={IMAGES.handshake}
          alt=""
          className="w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(105deg, rgba(28,37,65,0.95) 0%, rgba(28,37,65,0.78) 60%, rgba(28,37,65,0.55) 100%)",
          }}
        />
      </div>
      <div className="ra-grain absolute inset-0" />

      <div className="relative max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <div className="ra-eyebrow on-dark mb-6">
              <span className="ra-hairline" />
              <span>Make the Smart Move</span>
            </div>
            <h2
              data-testid="final-cta-headline"
              className="font-heading text-white text-3xl md:text-5xl lg:text-[58px] font-medium leading-[1.05] tracking-tight"
            >
              Make Better Decisions{" "}
              <span className="text-[#00A859]">Before Risk</span> Becomes Costly.
            </h2>
            <p className="font-body text-white/70 text-base md:text-lg leading-relaxed mt-8 max-w-2xl">
              Whether you&apos;re evaluating a development opportunity, seeking
              independent project oversight, improving operational performance,
              or navigating complex project risks, Ramo Advisors LLC provides
              experienced guidance to help you move forward with confidence.
            </p>
          </div>

          <div className="lg:col-span-4 lg:text-right">
            <button
              data-testid="final-cta-button"
              onClick={() => scrollToId("contact")}
              className="ra-btn-primary"
            >
              Schedule a Consultation
              <ArrowRight size={16} />
            </button>
            <div className="mt-6 font-body text-white/50 text-sm">
              Confidential conversations welcome.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
